module.exports = __webpack_public_path__ + "img/CompanyTitle.42fd94d4.png";